import { StatusEnum } from "../../store/users/models/internal";

// Statuses of user for when we should hide the CTA
export const unverifiableStatuses: Array<StatusEnum> = [
  "IN_REVIEW",
  "VERIFIED",
  "PENDING",
];
